import { useEffect, useState, useContext, useCallback } from 'react';
import teacherService from 'ApiService/Admin/teacherService';
import { AuthContext } from 'contexts/AuthContext';
import toast from 'react-hot-toast';

const SelectTeacher = ({
  setDisable,
  teacherData,
  setTeacherData,
  selectedDepartment,
}) => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState([]);
  const { state } = useContext(AuthContext);

  const fetchTeachers = useCallback(async () => {
    if (!selectedDepartment) return;
    setLoading(true);
    try {
      // Use the updated service that supports departmentId
      const response = await teacherService.getAllTeacher(
        null,
        null,
        selectedDepartment
      );
      if (response.data.success) {
        setTeachers(response.data.data || []);
      } else {
        toast.error('Failed to fetch teachers.');
        setTeachers([]);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch teachers.'
      );
      setTeachers([]);
    } finally {
      setLoading(false);
    }
  }, [selectedDepartment]);

  useEffect(() => {
    fetchTeachers();
  }, [fetchTeachers]);

  const handleTeacherChange = (event) => {
    const teacherId = event.target.value;
    setTeacherData((prev) => ({
      ...prev,
      teacherId: teacherId,
    }));
  };

  useEffect(() => {
    const newErrors = [];
    if (!teacherData?.teacherId) {
      newErrors.push('Please select a teacher');
    }
    setErrors(newErrors || []);
    setDisable((newErrors || []).length > 0);
  }, [setDisable, teacherData]);

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Teacher
        </h4>
      </div>
      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Teacher
          </label>
          <select
            onChange={handleTeacherChange}
            value={teacherData?.teacherId || ''}
            name="teacher"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Teacher</option>
            {loading ? (
              <option>Loading teachers...</option>
            ) : (
              <>
                {teachers?.map((teacher, i) => (
                  <option key={teacher._id} value={teacher._id}>
                    {i + 1}. {teacher.name}{' '}
                    {teacher.branch?._id !== state?.selectedBranch &&
                      `(${teacher.branch?.name || 'Other Branch'})`}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
      </div>

      {(errors || []).length > 0 && (
        <div className="mt-4 text-center text-red-500">
          {errors?.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectTeacher;
